// Tab "Đề xuất" của trang Bản đồ giao diện (chỉ Super): mọi bản NHÁP chưa được chọn — bot đề xuất, thư viện khối đổi mà Super đã tự sửa, nhập tệp, khảo sát.
// Mỗi mục: nguồn, khác gì bản đang dùng, rủi ro; hai việc: "Chọn để phát hành" (chỉ đặt làm bản SẼ phát hành, bấm Phát hành ở tab Thao tác mới có hiệu lực)
// và "Bỏ đề xuất" (đánh dấu đã bỏ, không xoá). Mọi chữ từ máy chủ chỉ vào textContent qua h(). Mỗi lần tải có gen() chống vẽ chồng.
import { api, errMsg } from "../api";
import { busy, clear, confirmBox, gen, h, toast } from "../dom";
import { fmtTime } from "../format";

interface DeXuat {
  id: string; nenTang: string; ma: string; pb: number; nguon: string; ghiChu: string | null; taoLuc: string; taoBoi: string | null;
  moTa: string; ruiRo: "thap" | "cao"; laMoi: boolean; trangThaiThaoTac: "moi" | "dang_dung" | "tam_ngung"; pbDangDung: number | null; khacBiet: string[];
}
interface Ds { tong: number; items: DeXuat[] }

const NHAN_NGUON: Record<string, string> = { khoi_tuy_chinh: "bot đề xuất", co_san: "thư viện khối đổi", nhap_tep: "nhập tệp", khao_sat: "khảo sát", super_day: "Super dạy" };
const NHAN_TRUONG: Record<string, string> = { moTa: "mô tả", thamSo: "tham số", ruiRo: "rủi ro", yamlSteps: "các bước", learned: "vị trí đã học", params: "tham số kịch bản", chamPhuHop: "lọc liên quan" };

export interface DeXuatOpts {
  moChiTiet: (id: string) => void; // sang tab Thao tác và mở chi tiết thao tác
  capNhatDem: (n: number) => void; // báo số đề xuất cho nhãn tab
}

export async function renderDeXuatTab(root: HTMLElement, opts: DeXuatOpts): Promise<() => void> {
  const alive = gen("ban-do-de-xuat");
  const loiBox = h("div", { class: "err-box", hidden: true, "data-testid": "bd-dx-error" });
  const info = h("p", { class: "muted small", "data-testid": "bd-dx-info" }, "Đang tải…");
  const ds = h("div", { class: "bd-dx-ds", "data-testid": "bd-dx-ds" });
  const btnTai = h("button", { type: "button", class: "mini", title: "Tải lại danh sách đề xuất", "data-testid": "bd-dx-reload" }, "Tải lại");

  async function tai(): Promise<void> {
    let d: Ds;
    try { d = await api<Ds>("GET", "/api/ban-do/cho-duyet"); }
    catch (e) { if (alive()) { loiBox.textContent = `Không tải được đề xuất: ${errMsg(e)}`; loiBox.hidden = false; info.textContent = ""; } return; }
    if (!alive()) return;
    loiBox.hidden = true;
    ve(d);
  }

  function ve(d: Ds): void {
    opts.capNhatDem(d.tong);
    clear(ds);
    info.textContent = d.tong ? `${d.tong} đề xuất chờ duyệt${d.tong > d.items.length ? ` (đang hiện ${d.items.length} mới nhất)` : ""}` : "";
    if (!d.items.length) {
      ds.append(h("p", { class: "empty", "data-testid": "bd-dx-empty" }, "Không có đề xuất nào chờ duyệt. Đề xuất của bot, bản nháp từ thư viện khối và bản nhập từ tệp sẽ hiện ở đây."));
      return;
    }
    for (const x of d.items) ds.append(the(x));
  }

  function the(x: DeXuat): HTMLElement {
    const khac = x.laMoi
      ? "Thao tác MỚI (chưa có trong bản đồ)."
      : x.trangThaiThaoTac === "tam_ngung"
        ? "Thao tác đang tạm ngưng — chọn bản này KHÔNG bật lại nó, chỉ có bản mới để dùng sau."
        : x.khacBiet.length ? `Khác bản đang dùng v${x.pbDangDung}: ${x.khacBiet.map((k) => NHAN_TRUONG[k] ?? k).join(", ")}.` : `Khác bản đang dùng v${x.pbDangDung} ở chi tiết nhỏ.`;
    const btnChon = h("button", { type: "button", class: "mini pri", title: "Đặt bản này làm bản SẼ phát hành tới. Chưa có hiệu lực cho tới khi bạn bấm Phát hành ở tab Thao tác.", "data-testid": "bd-dx-chon" }, "Chọn để phát hành");
    const btnBo = h("button", { type: "button", class: "mini danger", title: "Bỏ đề xuất này (đánh dấu đã bỏ, không xoá). Đề xuất y hệt sau này sẽ không hiện lại.", "data-testid": "bd-dx-bo" }, "Bỏ đề xuất");
    const btnXem = h("button", { type: "button", class: "mini", title: "Mở chi tiết thao tác ở tab Thao tác", "data-testid": "bd-dx-xem" }, "Xem chi tiết");
    btnChon.addEventListener("click", () => void busy(btnChon, "Đang chọn…", async () => {
      try {
        await api("POST", `/api/ban-do/thao-tac/${encodeURIComponent(x.id)}/chon`, { pb: x.pb });
        toast(`Đã chọn v${x.pb} của ${x.nenTang}/${x.ma} — bấm Phát hành ở tab Thao tác để áp dụng`);
      } catch (e) { toast(errMsg(e), "err"); }
      await tai();
    }));
    btnBo.addEventListener("click", () => void busy(btnBo, "Đang bỏ…", async () => {
      const ok = await confirmBox({ title: `Bỏ đề xuất ${x.nenTang}/${x.ma} v${x.pb}?`, text: "Bản này sẽ được đánh dấu đã bỏ và không hiện lại. Không ảnh hưởng bản đang dùng.", okText: "Bỏ đề xuất", danger: true });
      if (!ok) return;
      try {
        await api("POST", `/api/ban-do/thao-tac/${encodeURIComponent(x.id)}/pb/${x.pb}/bo`, {});
        toast("Đã bỏ đề xuất");
      } catch (e) { toast(errMsg(e), "err"); }
      await tai();
    }));
    btnXem.addEventListener("click", () => opts.moChiTiet(x.id));
    return h("div", { class: "bd-dx-the", "data-testid": "bd-dx-item", dataset: { id: x.id, ma: x.ma, nenTang: x.nenTang, pb: String(x.pb), nguon: x.nguon } },
      h("div", { class: "row between" },
        h("span", { class: "wrap" }, h("b", {}, `${x.nenTang}/${x.ma}`), ` · v${x.pb}`),
        h("span", { class: "row", style: "gap:6px;flex-wrap:wrap" },
          h("span", { class: "tag", "data-testid": "bd-dx-nguon" }, NHAN_NGUON[x.nguon] ?? x.nguon),
          x.laMoi ? h("span", { class: "tag ok" }, "mới") : null,
          x.ruiRo === "cao" ? h("span", { class: "tag err", title: "có bước đăng/bình luận/thích thật" }, "rủi ro cao") : null)),
      x.moTa ? h("p", { class: "small wrap" }, x.moTa) : null,
      h("p", { class: "small", "data-testid": "bd-dx-khac" }, khac),
      h("p", { class: "muted small wrap" }, [x.ghiChu, x.taoBoi ? `bởi ${x.taoBoi}` : null, fmtTime(x.taoLuc)].filter(Boolean).join(" · ")),
      h("div", { class: "row", style: "gap:8px;flex-wrap:wrap" }, btnChon, btnBo, btnXem));
  }

  btnTai.addEventListener("click", () => void busy(btnTai, "Đang tải…", tai));
  root.append(
    h("div", { class: "toolbar row" }, h("h3", { class: "grow" }, "Đề xuất chờ duyệt"), btnTai),
    h("p", { class: "muted small" }, "Bản nháp chưa được chọn: bot đề xuất, thư viện khối đổi mà bạn đã tự sửa, nhập từ tệp. Chọn thì bản đó thành bản SẼ phát hành (bấm Phát hành mới có hiệu lực); bỏ thì không hiện lại."),
    loiBox, info, ds);
  await tai();
  return () => { /* gen() đã vô hiệu hoá các lần tải đang bay khi vào lần render mới */ };
}

// Chỉ lấy số đề xuất (nhãn tab) — không tải danh sách.
export async function demDeXuat(): Promise<number> {
  const d = await api<{ tong: number }>("GET", "/api/ban-do/cho-duyet?dem=1");
  return d.tong;
}
